import {
  Box,
  Img,
  Icon,
  Text,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { getGameById, getSkills } from 'utils/game/gameService';

import back from 'assets/img/screens/back.png';
import write from 'assets/img/screens/Writing.png';
import { useParams } from 'react-router-dom';
import { FaClock } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducers';
import next from 'assets/img/screens/next.png';

import AuthorArrow from 'assets/img/screens/authorArrow.png';
import NoteArrow from 'assets/img/screens/noteArrow.png';
import learningOutcome from 'assets/img/games/Gameplay/learningOutcome.png';
import skillsArrow from 'assets/img/games/Gameplay/skillsArrow.png';
import { HashLoader } from 'react-spinners';
import Scrollbar from 'components/customScroll/CustomScroll';
interface Badge {
  gasId: number;
  gasAssetImage: string;
  gasAssetName: string;
}

const WelcomeContentScreen: React.FC<{
  background?: any;
  formData: any;
  imageSrc: any;
  preview: any;
  preloadedAssets?: any;
}> = ({ formData, imageSrc, preview, background, preloadedAssets }) => {
  const { id } = useParams();
  const [profile, setProfile] = useState<any>([]);
  const [apSkl, setApSkl] = useState([]);
  const [authorArray, setauthorArray] = useState<any[]>([]);
  const { currentTab } = useSelector((state: RootState) => state.preview);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const fetch = async () => {
    const result = await getGameById(id);
    if (result?.status !== 'Success') {
      setProfile([]);
      return console.log('getbackruond error:' + result?.message);
    } else {
      setProfile(result.data);
    }

    const res = await getSkills();
    if (res?.status === 'Success') {
      setApSkl(res?.data);
    }
  };
  const customStylesicon = {
    cursor: 'pointer',
    color: '#D9C7A2',
    marginRight: '4px',
  };

  useEffect(() => {
    fetch();
    const dataLearn =
      formData?.gameLearningOutcome !== null
        ? formData?.gameLearningOutcome?.split('\n')
        : [];
    setData(dataLearn);
  }, []);

  useEffect(() => {
    if (profile.gameSkills) {
      const Array = profile.gameSkills.split(',');
      setauthorArray(Array);
    }
  }, [profile]);

  const findSkillName = (authorNumber: any) => {
    const matchedSkill = apSkl.find(
      (option: any) => option.id === Number(authorNumber),
    );
    return matchedSkill ? matchedSkill.name : null;
  };

  const renderContent = () => {
    const linkRegex = /(https?:\/\/[^\s]+)/g;

    const parts = formData?.gameAdditionalWelcomeNote?.split(linkRegex);

    const contentWithLinks = parts?.map((part: any, index: any) => {
      if (linkRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            style={{ color: '#caa784', textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </a>
        );
      } else {
        return <React.Fragment key={index}>{part}</React.Fragment>;
      }
    });

    return <React.Fragment>{contentWithLinks}</React.Fragment>;
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <motion.div
        initial={{ opacity: 0, background: '#000' }}
        animate={{ opacity: 1, background: '#0000' }}
        transition={{ duration: 0.5, delay: 0.5 }}
        style={{ height: '100%' }}
      >
        {imageSrc &&
        preview &&
        currentTab === 5 &&
        (formData.gameIsShowSkill === 'true' ||
          formData.gameIsShowLearningOutcome === 'true' ||
          formData.gameIsShowAuhorName === 'true' ||
          formData.gameIsShowStoryline === 'true' ||
          formData.gameIsShowGameDuration === 'true' ||
          formData.gameIsShowAdditionalWelcomeNote === 'true') ? (
          <Box className="welcome-screen">
            <Box className="welcome-screen-box">
              <Img
                src={imageSrc}
                className=" welcome-pad"
                onLoad={() => setLoading(false)}
              />
            </Box>
            <Box className="top-title">
              <Text
                className="title"
                fontSize={{
                  base: '13px',
                  sm: '13px',
                  md: '15px',
                  lg: '20px',
                }}
              >
                {formData.gameTitle}
              </Text>

              <Text
                className="duration"
                fontSize={{
                  base: '11px',
                  sm: '12px',
                  md: '13px',
                  lg: '15px',
                }}
                mt={'2px'}
                fontFamily={'content'}
                position={'absolute'}
                display={'flex'}
                alignItems={'center'}
              >
                <>
                  {' '}
                  <Icon as={FaClock} style={customStylesicon} />{' '}
                  <span style={customStylesicon}>
                    {formData.gameDuration > 1
                      ? Math.round(formData.gameDuration * 0.6) + ' mins'
                      : 'Few mins'}
                  </span>
                </>
              </Text>
            </Box>
            <Box className="content-box" fontFamily={'gametext'}>
              <Box w={'60%'} className="content">
                <Text
                  className="text"
                  mt={'20px'}
                  fontSize={{
                    base: '11px',
                    sm: '12px',
                    md: '13px',
                    lg: '15px',
                  }}
                  fontFamily={'content'}
                >
                  {formData.gameStoryLine}
                </Text>

                <Box display={'flex'} className={'rewards-box'}>
                  <>
                    <Box className="box-1">
                      <Img src={back} className="bg-img" />
                      <Text
                        className="skill-text"
                        style={{ textAlign: 'center' }}
                        fontFamily={'content'}
                        color={'black'}
                      >
                        Skills
                      </Text>
                      <Box
                        className="inside-box"
                        transform={'translate(-2px, -125px)'}
                        mt={'10px'}
                        w={'100%'}
                        h={'60px'}
                        overflowY={'scroll'}
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        flexDirection={'column'}
                      >
                        {authorArray
                          .map((authorItem, index) => {
                            const skillName = findSkillName(authorItem);
                            return skillName;
                          })
                          .filter((skillName) => skillName !== null)
                          .map((filteredSkillName, index) => (
                            <Box display={'flex'} key={index}>
                              <Img src={write} w={'16px'} h={'16px'} />
                              <Box>
                                <Box
                                  className="text-wrapper"
                                  display={'flex'}
                                  w={'50px'}
                                  h={'20px'}
                                  justifyContent={'space-between'}
                                  fontWeight={'300'}
                                  marginLeft={'5px'}
                                >
                                  <Text color={'#D9C7A2'}>
                                    {filteredSkillName}
                                  </Text>
                                  <Text></Text>
                                </Box>
                              </Box>
                            </Box>
                          ))}
                      </Box>
                    </Box>
                  </>
                  <>
                    <Box className="box-1">
                      <Img src={back} className="bg-img" />
                      <Text
                        className="skill-text"
                        style={{ textAlign: 'center' }}
                        fontFamily={'content'}
                        color={'black'}
                      >
                        Learning Outcomes
                      </Text>
                      <Box
                        className="inside-box"
                        transform={'translate(-2px, -125px)'}
                        mt={'10px'}
                        w={'100%'}
                        h={'60px'}
                        overflowY={'scroll'}
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        flexDirection={'column'}
                      >
                        {data &&
                          data.map((it: any, ind: number) => {
                            const bulletIndex = it.indexOf('\u2022');
                            const contentAfterBullet =
                              bulletIndex !== -1
                                ? it.slice(bulletIndex + 1).trim()
                                : it;
                            return (
                              <Box display={'flex'} key={ind}>
                                <Img src={write} w={'16px'} h={'16px'} />
                                <Box>
                                  <Box
                                    className="text-wrapper"
                                    display={'flex'}
                                    w={'50px'}
                                    h={'20px'}
                                    justifyContent={'space-between'}
                                    fontWeight={'300'}
                                    marginLeft={'5px'}
                                  >
                                    <Text color={'#D9C7A2'}>
                                      {contentAfterBullet}
                                    </Text>
                                    <Text></Text>
                                  </Box>
                                </Box>
                              </Box>
                            );
                          })}
                      </Box>
                    </Box>
                  </>
                </Box>
                <Box
                  w={'100%'}
                  h={'50px'}
                  position={'relative'}
                  className="author"
                >
                  <Text
                    position={'absolute'}
                    right={'0px'}
                    left={'0px'}
                    bottom={'0px'}
                    top={'20px'}
                    fontSize={{
                      base: '11px',
                      sm: '12px',
                      md: '13px',
                      lg: '15px',
                    }}
                    fontFamily={'content'}
                    color={'black'}
                  >
                    *Author* <br /> {formData.gameAuthorName}
                  </Text>
                </Box>
                <Box className="renderContent">
                  <Text
                    fontSize={{
                      base: '11px',
                      sm: '12px',
                      md: '13px',
                      lg: '15px',
                    }}
                    fontFamily={'content'}
                  >
                    {renderContent()}
                  </Text>
                </Box>
              </Box>
            </Box>
            <Box className="next-btn">
              <Img src={preloadedAssets.next} />
            </Box>
          </Box>
        ) : (
          <>
            <Box
              w={'100%'}
              h={'100%'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <Box
                w={'auto'}
                position={'relative'}
                h={'100%'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <Img
                  src={imageSrc}
                  onLoad={() => setLoading(false)}
                  h={{ base: '100%', sm: '100%', md: 'auto' }}
                  w={{ base: 'auto', sm: 'auto', md: '90%' }}
                  transition={'transform 0.3s ease'}
                  transform={{ lg: 'scale(1.2)', '2xl': 'scale(1.3)' }}
                  objectFit={'contain'}
                />
                <Box
                  position={'absolute'}
                  transition={'transform 0.3s ease'}
                  transform={{ lg: 'scale(1.1)', '2xl': 'scale(1.25)' }}
                  display={'flex'}
                  justifyContent={'center'}
                  w={'75%'}
                  h={{ base: '51%', sm: '45%', md: '42%', lg: '34%' }}
                  top={{ base: '25.5%', sm: '30.5%', md: '31.5%', lg: '34.5%' }}
                  fontFamily={'AtlantisContent'}
                >
                  <Box
                    w={'100%'}
                    display={'flex'}
                    justifyContent={'center'}
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Box
                      w={{ base: '60%', sm: '60%', md: '24%' }}
                      lineHeight="23px"
                    >
                      <Text className="game_welcome_title">
                        {formData.gameTitle}
                      </Text>
                      {formData.gameIsShowGameDuration === 'true' && (
                        <Text className="game_welcome_duration">
                          <>
                            {' '}
                            <Icon as={FaClock} style={customStylesicon} />{' '}
                            <span style={customStylesicon}>
                              {formData.gameDuration > 1
                                ? Math.round(formData.gameDuration * 0.6) +
                                  'mins'
                                : 'Few mins'}
                            </span>
                          </>
                        </Text>
                      )}
                    </Box>
                    <Box
                      className="content-box"
                      fontFamily={'AtlantisContent'}
                      display={'flex'}
                      justifyContent={'center'}
                      height={'70%'}
                    >
                      <Box
                        w={'60%'}
                        className="welcome_content"
                        overflow={'auto'}
                      >
                        <Scrollbar>
                          {formData.gameIsShowStoryline === 'true' && (
                            <Text className="text_welcome">
                              {formData.gameStoryLine}
                            </Text>
                          )}

                          <Box
                            className={
                              formData.gameIsShowSkill === 'true' ||
                              formData.gameIsShowLearningOutcome === 'true'
                                ? 'rewards-box'
                                : 'empty-rewards-box'
                            }
                          >
                            {formData.gameIsShowSkill === 'true' && (
                              <>
                                <Box className="box-1">
                                  <Img
                                    // className="rewards-arrow-img"
                                    display={'block !important'}
                                    src={skillsArrow}
                                    mt={'10px'}
                                    alt="skill"
                                    w={'100%'}
                                    h={'auto'}
                                  />
                                  <Box
                                    className="inside-box"
                                    mt={'10px'}
                                    w={'100%'}
                                  >
                                    {authorArray
                                      .map((authorItem, index) => {
                                        const skillName =
                                          findSkillName(authorItem);
                                        return skillName;
                                      })
                                      .filter((skillName) => skillName !== null)
                                      .map((filteredSkillName, index) => (
                                        <Box display={'flex'} key={index}>
                                          <Img
                                            src={write}
                                            w={'16px'}
                                            h={'16px'}
                                          />
                                          <Box ml={'10px'}>
                                            <Box
                                              className="text-wrapper"
                                              display={'flex'}
                                              justifyContent={'space-between'}
                                              fontWeight={'300'}
                                              marginLeft={'5px'}
                                              fontSize={'1.5vh'}
                                            >
                                              <Text
                                                color={'#D9C7A2'}
                                                letterSpacing={'1px'}
                                              >
                                                {filteredSkillName}
                                              </Text>
                                              <Text></Text>
                                            </Box>
                                          </Box>
                                        </Box>
                                      ))}
                                  </Box>
                                </Box>
                              </>
                            )}
                            {formData.gameIsShowLearningOutcome === 'true' && (
                              <>
                                <Box className="box-1">
                                  <Img
                                    // className="rewards-arrow-img"
                                    display={'block !important'}
                                    src={learningOutcome}
                                    mt={'10px'}
                                    alt="Learning outcome"
                                    w={'100%'}
                                    h={'auto'}
                                  />
                                  <Box
                                    className="inside-box"
                                    mt={'10px'}
                                    w={'100%'}
                                  >
                                    {data &&
                                      data.map((it: any, ind: number) => {
                                        const bulletIndex =
                                          it.indexOf('\u2022');
                                        const contentAfterBullet =
                                          bulletIndex !== -1
                                            ? it.slice(bulletIndex + 1).trim()
                                            : it;
                                        return (
                                          <Box display={'flex'} key={ind}>
                                            <Img
                                              src={write}
                                              w={'16px'}
                                              h={'16px'}
                                            />
                                            <Box ml={'10px'}>
                                              <Box
                                                className="text-wrapper"
                                                display={'flex'}
                                                // w={'50px'}
                                                // h={'20px'}
                                                justifyContent={'space-between'}
                                                fontWeight={'300'}
                                                marginLeft={'5px'}
                                                fontSize={'1.5vh'}
                                              >
                                                <Text
                                                  color={'#D9C7A2'}
                                                  letterSpacing={'1px'}
                                                >
                                                  {contentAfterBullet}
                                                </Text>
                                                <Text></Text>
                                              </Box>
                                            </Box>
                                          </Box>
                                        );
                                      })}
                                  </Box>
                                </Box>
                              </>
                            )}
                          </Box>
                          {formData.gameIsShowAuhorName === 'true' && (
                            <Box
                              width={'100%'}
                              // position= {'inherit'}
                              height={'auto'}
                              color={'#D9C7A2'}
                              className="author"
                            >
                              <Img src={AuthorArrow} w={'100%'} h={'auto'} />
                              <Text
                                fontSize={'1.5vh'}
                                textAlign={'center'}
                                letterSpacing={'1px'}
                              >
                                {formData.gameAuthorName}
                              </Text>
                            </Box>
                          )}
                          {formData.gameIsShowAdditionalWelcomeNote ===
                            'true' && (
                            <Box className="text_cont" textAlign={'center'}>
                              <Img src={NoteArrow} w={'100%'} h={'auto'} />
                              <Text fontSize={'1.5vh'} letterSpacing={'1px'}>
                                {renderContent()}
                              </Text>
                            </Box>
                          )}
                        </Scrollbar>
                      </Box>
                    </Box>
                    <Box
                      w={'100%'}
                      mt="5px"
                      display={'flex'}
                      justifyContent={'center'}
                    >
                      <Img
                        src={next}
                        h={{ base: '2rem', sm: '2rem', md: '2.5rem' }}
                        w="auto"
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </>
        )}
      </motion.div>
    </>
  );
};
export default WelcomeContentScreen;
